import IMG from "../../constants/image";
import React, {useEffect, useMemo, useState} from "react";
import Button from "../Common/Button";
import {PATH, PRODUCT_STATUS, VARIANT} from "../../constants";
import './style.css';
import SearchInput from "../Common/Input/SearchInput";
import CustomTabs from "../Common/Tabs";
import ProductItem from "./ProductItem";
import {useNavigate} from "react-router-dom";
import Pagination from "../Common/Pagination/Pagination";
import productStore from "../../store/productStore";
import EmptyProduct from "../Empty/EmptyProduct";
import {deleteProductItem, updateProductStatus} from "../../network/api";
import popupStore from "../../store/popupStore";
import cn from "classnames";
import merchantStore from "../../store/merchantStore";
import IconText from "../Common/Text/IconText";
import {text} from "../../constants/text";

const ORDER = {
    ASC: 'ASC',
    DESC: 'DESC',
}

const ProductList = ({isSearchMobile, openSearchMobile}) => {
    const navigate = useNavigate();
    const {setPopup} = popupStore() || {};
    const {statusCount, productData, getProducts, getStatusCount, clearProductData} = productStore() || {};
    const {merchantProfile} = merchantStore() || {};
    const [page, setPage] = useState(1);
    const [tab, setActiveTab] = useState({id: 0});

    const [filter, setFilter] = useState({
        activeFilter: 'orderDate',
        orderDate: ORDER.DESC,
        orderPrice: ORDER.ASC,
    });

    const {orderDate, orderPrice, activeFilter} = filter || {};
    const [searchString, setSearch] = useState('');
    const {count, data: products} = productData || {};

    useEffect(() => {
        if (merchantProfile) {
            getStatusCount();
        }
        return () => {
            clearProductData();
        }
    }, [merchantProfile])

    useEffect(() => {
        if (merchantProfile) {
            handleGetProducts();
        }
    }, [searchString, filter, tab, page, merchantProfile]);


    const rejectCount = useMemo(() => {
        const rejectStatus = (statusCount || []).find(item => item?.status === PRODUCT_STATUS.REJECTED)
        return rejectStatus?.count || 0
    }, [statusCount])

    const handleGetProducts = () => {
        // Implement your logic here
        const params = {
            limit: 10,
            page,
        }
        if (tab?.status && tab?.status !== PRODUCT_STATUS.ALL) {
            params.status = tab.status;
        }
        if (searchString) params.search = searchString;
        if (activeFilter === 'orderDate') {
            params.sort_by = 'created_at'
            params.sort_direction = orderDate
        } else if (activeFilter === 'orderPrice') {
            params.sort_by = 'price'
            params.sort_direction = orderPrice
        }
        getProducts(params);
    }

    const handleShowRejected = () => {
        setActiveTab((statusCount || []).find(item => item?.status === PRODUCT_STATUS.REJECTED));
    }

    const renderContent = () => {
        if (products?.length === 0 && (searchString || tab?.status)) {
            return (
                <div
                    className='w-fit mx-auto flex flex-col p-4 justify-center items-center md:px-[70px] md:py-[50px] gap-10'
                >
                    <img className='w-[194px] h-[135px]' src={IMG.emptyProduct} alt="emptyProduct"/>
                    <p className='text-center text-sm'>
                        Không tìm thấy sản phẩm nào phù hợp<br/>
                    </p>
                </div>
            )
        }

        return (
            <>
                {(!tab?.id && rejectCount > 0) &&
                    <div className='md:hidden flex justify-between rounded-md bg-[#FFF9E3] text-xs p-[5px] mb-[5px]'>
                        <IconText
                            icon={IMG.icon.exclamationRed}
                            iconClass='w-3 h-3'
                            textChild={<p>Có <span className='text-red-600'>{rejectCount || 0}</span> sản phẩm bị từ
                                chối</p>}
                        />
                        <Button className='bg-[#F8C51880] text-[10px] h-3' onClick={handleShowRejected}>
                            {text.viewNow}
                        </Button>
                    </div>
                }
                {
                    (products || []).map((product, index) => {
                        return (
                            <ProductItem
                                key={index}
                                productDetail={product}
                                checkUpdateStatus={checkUpdateStatus}
                                deleteProduct={deleteProduct}
                            />
                        )
                    })
                }
            </>
        )
    }

    const handleChangeTab = (tab) => {
        setActiveTab(tab)
    }

    const onChangeFilterOrderDate = (name, value) => {
        if (filter.activeFilter === 'orderDate') {
            if (filter.orderDate === ORDER.ASC) {
                setFilter({...filter, orderDate: ORDER.DESC})
            } else if (filter.orderDate === ORDER.DESC) {
                setFilter({...filter, orderDate: ORDER.ASC})
            }
        } else {
            setFilter({...filter, activeFilter: 'orderDate'})
        }
    }
    const onChangeFilterOrderPrice = () => {
        if (orderPrice === ORDER.DESC) {
            setFilter({...filter, activeFilter: 'orderPrice', orderPrice: ORDER.ASC})
        } else {
            setFilter({...filter, activeFilter: 'orderPrice', orderPrice: ORDER.DESC})
        }
    }

    const onSearch = (searchText) => {
        setSearch(searchText)
    }

    const deleteProduct = (productDetail) => {
        const {id, status} = productDetail || {}

        setPopup({
            isOpen: true,
            data: {
                title: 'Bạn muốn xoá sản phẩm này?',
                image: IMG.popupUpdateStatus,
                accept: {
                    label: 'Đồng ý',
                    action: () => handleDeleteProductItem({productId: id})
                },
                cancel: {
                    label: 'Hủy',
                    action: () => setPopup({})
                }
            }
        })
    }

    const checkUpdateStatus = (productDetail) => {
        const {id, status} = productDetail || {}
        let newStatus = ''
        let title = ''
        if (status === PRODUCT_STATUS.DRAFT || status === PRODUCT_STATUS.PROPOSED) {
            newStatus = PRODUCT_STATUS.PUBLISHED
            title = 'Bạn muốn bật sản phẩm này?'
        } else if (status === PRODUCT_STATUS.PUBLISHED) {
            newStatus = PRODUCT_STATUS.PROPOSED
            title = 'Bạn muốn tắt sản phẩm này?'
        }

        setPopup({
            isOpen: true,
            data: {
                title: title,
                image: IMG.popupUpdateStatus,
                isHideButtonClose: true,
                btnCancelNew: {
                    label: 'Huỷ',
                    action: () => setPopup({})
                },
                accept: {
                    label: 'Đồng ý',
                    action: () => updateStatus({productId: id, status: newStatus})
                },
            }
        })

    }

    const updateStatus = async ({productId, status}) => {
        const res = await updateProductStatus({productId, status});
        if (res?.success) {
            handleGetProducts();
            getStatusCount()
        }
        setPopup({})
    }

    const handleDeleteProductItem = async ({productId}) => {
        const res = await deleteProductItem({productId});
        if (res?.success) {
            handleGetProducts();
        }
        setPopup({})
    }

    if (productData && products?.length === 0 && !searchString && !tab?.status) {
        return <EmptyProduct/>
    }

    return (
        <div
            className='w-full flex flex-col justify-center items-center md:gap-5 pb-[90px] bg-white md:py-5'>
            <Button className='hidden md:block w-[380px]' variant={VARIANT.PRIMARY}
                    onClick={() => navigate(PATH.CREATE_PRODUCT)}>
                + Thêm sản phẩm mới
            </Button>
            <div
                className='w-full flex flex-col md:flex-row px-4 md:py-4 pb-4 items-center justify-between bg-[#EDEDED] md:bg-[#FAFAFC] md:border-t border-b'>
                <div className='flex w-full justify-between items-center text-sm gap-2.5'>
                    <SearchInput
                        placeholder='Tìm sản phẩm'
                        onSearch={onSearch}
                    />
                    <p className='hidden' onClick={() => openSearchMobile(false)}>Huỷ</p>
                </div>
                <div
                    className='flex w-full justify-between md:justify-center items-center gap-2.5 text-sm mt-4 md:mt-0 md:px-0'>
                    <div className='flex justify-center items-center gap-2.5'>
                        <p className='font-bold'>Sắp xếp theo: </p>
                        <p
                            className={cn('w-[65px] cursor-pointer', activeFilter === 'orderDate' && 'text-[#197D55]')}
                            onClick={onChangeFilterOrderDate}>
                            {orderDate === ORDER.DESC ? 'Mới nhất' : 'Cũ nhất'}</p>
                    </div>
                    <div
                        className='flex justify-center items-center gap-2.5'
                        onClick={onChangeFilterOrderPrice}>
                        <p className={cn('font-bold', activeFilter === 'orderPrice' && 'text-[#197D55]')}>Giá: </p>
                        <p
                            className={cn(
                                'flex justify-center items-center gap-2.5 cursor-pointer',
                                activeFilter === 'orderPrice' && 'text-[#197D55]',
                            )}
                        >
                            <span
                                className='hidden md:block'>{orderPrice === ORDER.ASC ? "Tăng dần" : "Giảm dần"}</span>
                            <img className={cn(orderPrice === ORDER.DESC && 'rotate-180')} src={IMG.icon.arrowUp}
                                 alt=""/>
                        </p>
                    </div>
                </div>
            </div>
            <CustomTabs
                renderContent={renderContent}
                handleChangeTab={handleChangeTab}
                tabActive={tab}
                tabs={statusCount || []}
            />

            {count > 1 && (
                <Pagination
                    totalItems={count}
                    itemsPerPage={10}
                    setPage={setPage}
                />
            )}
        </div>
    )
};

export default ProductList;
